import { call, put } from "redux-saga/effects";
import { actions as searcherActions } from "@/reducers/searcher";
import { getDeviceListItems } from "@/sagas/devices-list";

export function* performAutocompleteQuery(args) {
    try {
        const { data } = args;
        const { query, id } = data;
        const getDevicesData = {
            queryParams: {
                query,
                pageSize: 12,
                isPredictiveSearch: true,
            },
            id
        }
        const response = yield call(getDeviceListItems, { data: getDevicesData });
        const { productsCards } = response;
        let hits = [];
        if (Array.isArray(productsCards)) {
            hits = productsCards.filter(({ name }) => name).map((product) => ({
                name: product.genericName,
            }));
        }
        yield put(searcherActions.successAutocompleteQuery({ hits, query }));
        console.log("performAutocompleteQuery data", response);

    } catch (error) {
        yield put(searcherActions.failureAutocompleteQuery());
        console.log("performAutocompleteQuery Error", error);
    }
}